import axios from 'axios';

const getSistemas = (SA_API, cpf) => {
  return axios.get(SA_API + 'keycloak/usuario/sistema/' + cpf).then((resp) => resp.data);
};

export default {
    getSistemas
};